import { NotePlayerNote } from "../Sound/NotePlayer";
import { Music } from "../Util/Music/Music";

export function allNotes_high_timestamps(){
        const notes:NotePlayerNote[] = [
            {tonic:Music.C, octave:0,    time:0},
            {tonic:Music.Db, octave:0,   time:2000},
            {tonic:Music.D, octave:0,    time:4000},
            {tonic:Music.Eb, octave:0,   time:6000},
            {tonic:Music.E, octave:0,    time:8000},
            {tonic:Music.F, octave:0,    time:10000},
            {tonic:Music.Gb, octave:0,   time:12000},
            {tonic:Music.G, octave:0,    time:14000},
            {tonic:Music.Ab, octave:0,   time:16000},
            {tonic:Music.A, octave:0,    time:18000},
            {tonic:Music.Bb, octave:0,   time:20000},
            {tonic:Music.B, octave:0,    time:22000},
    
    
            {tonic:Music.C, octave:1,    time:24000},
            {tonic:Music.Db, octave:1,   time:26000},
            {tonic:Music.D, octave:1,    time:28000},
            {tonic:Music.Eb, octave:1,   time:30000},
            {tonic:Music.E, octave:1,    time:32000},
            {tonic:Music.F, octave:1,    time:34000},
            {tonic:Music.Gb, octave:1,   time:36000},
            {tonic:Music.G, octave:1,    time:38000},
            {tonic:Music.Ab, octave:1,   time:40000},
            {tonic:Music.A, octave:1,    time:42000},
            {tonic:Music.Bb, octave:1,   time:44000},
            {tonic:Music.B, octave:1,    time:46000},
    
    
            {tonic:Music.C, octave:2,    time:48000},
            {tonic:Music.Db, octave:2,   time:50000},
            {tonic:Music.D, octave:2,    time:52000},
            {tonic:Music.Eb, octave:2,   time:54000},
            {tonic:Music.E, octave:2,    time:56000},
            {tonic:Music.F, octave:2,    time:58000},
            {tonic:Music.Gb, octave:2,   time:60000},
            {tonic:Music.G, octave:2,    time:62000},
            {tonic:Music.Ab, octave:2,   time:64000},
            {tonic:Music.A, octave:2,    time:66000},
            {tonic:Music.Bb, octave:2,   time:68000},
            {tonic:Music.B, octave:2,    time:70000},
        ]
        return notes
}